export type SupportGroupLevel = 'N1' | 'N2' | 'N3';

export const SUPPORT_GROUP_LEVELS: SupportGroupLevel[] = ['N1', 'N2', 'N3'];

export interface SupportGroupUser {
  id: string;
  name?: string | null;
  email?: string | null;
}

export interface SupportGroup {
  id: number;
  name: string;
  level: SupportGroupLevel;
  parentGroupId?: number | null;
  active: boolean;
  users: SupportGroupUser[];
}

export interface SupportGroupFormData {
  name: string;
  level: SupportGroupLevel;
  parentGroupId?: number | null;
  userIds: string[];
}

export interface SupportGroupFilters {
  searchTerm?: string;
  level?: SupportGroupLevel;
  active?: boolean;
}

export interface SupportGroupAssignableUser {
  id: string;
  firstName: string;
  lastName: string;
}
